import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, throwError, Observable } from "rxjs";
import { AuthService } from "./service/auth.service";

import { catchError, filter, take, switchMap } from "rxjs/operators";
import { Router } from "@angular/router";
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(public authService: AuthService, private router: Router) { }

  response_handle!: Observable<HttpEvent<any>>;

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.authService.getJwtToken()) {
      request = this.addToken(request, this.authService.getJwtToken());
    }
    return next.handle(request)
      .pipe(
        catchError((error) => {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            return this.handle401Error(request, next);
          }
          else if (error instanceof HttpErrorResponse && error.status === 400) {
            return this.handle400Error(request, next, error);
          }
          else {
            return throwError(error);
          }
        })
      );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      return this.authService.refreshToken()
        .pipe(
          switchMap((token: any) => {
            this.isRefreshing = false;
            this.refreshTokenSubject.next(token.data.jwt);
            return next.handle(this.addToken(request, token.data.jwt));
          }),
          catchError((error) => {
            this.authService.logout().subscribe(x => this.router.navigate(["/sign-in"]));
            return throwError(() => error);
          })
        );
    } else {
      return this.refreshTokenSubject
        .pipe(
          filter((token) => token != null),
          take(1),
          switchMap((jwt: any) => {
            return next.handle(this.addToken(request, jwt));
          }),
          catchError((error) => {
            this.authService.logout().subscribe(x => this.router.navigate(["/sign-in"]));
            return throwError(() => error);
          })
        );
    }
  }

  private handle400Error(request: HttpRequest<any>, next: HttpHandler, error: any) {
    const _message = error.error.message;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/error"]).then(() => {
      })
    });
    const _result = this.response_handle;
    console.log('error 400 en solicitud');
    console.log(request);
    console.log(error);
    return _result;
  }

  private addToken(request: HttpRequest<any>, token: string | null) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

}

